import request from '../../axios';

const deleteSaleAgent = async (guid: string) => {
  await request.delete(`api/v2/store/user-sale-agent/${guid}`);
};

export default deleteSaleAgent;
